"use strict";
var $ = require("../internals/export");
var uncurryThis = require("../internals/function-uncurry-this");
var $Date = Date;
var thisTimeValue = uncurryThis($Date.prototype.getTime);
$({ target: "Date", stat: true }, {
  now: function now() {
    return thisTimeValue(new $Date());
  }
});
